import React, { useMemo, useState } from "react";
import { CustomForm } from "shared/AllInputs";
import CustomOverlay from "shared/CustomOverlay";
import { useDispatch } from "react-redux";
import CrossIcon from "assets/images/svg/cross-icon.svg";
import SaveIcon from "assets/images/svg/Save-icon.svg";
import SizeM2 from "assets/images/svg/SizeM2.svg";
import EuroIcon from "assets/images/svg/euroIcon.svg"
import { TenantsOptions } from "shared/AllDropDownOptions";
import CustomViewTable from "views/Tables/CustomViewTable";
import { showFormErrors } from "utils/commonFunctions";
import { DropdownEditor, NumberEditor } from "views/Tables/TableInputs";
import { deleteBaseRentsAction, updateBaseRentsAction } from "store/actions/rentsetupActions";
import CustomDeleteModal from "shared/Modals/CustomDeleteModal";
import { CustomAmountViewInput, CustomNumberViewInput, CustomViewInput } from "shared/AllViewInputs";
import { getTenantName } from "../CommonComponents/functions";

export default function ViewBaseRentTable({
    id,
    title,
    allValues,
    setAllValues,
    header
}) {
    const dispatch = useDispatch();
    const [editingRows, setEditingRows] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idToDelete, setIdToDelete] = useState({ id: "", index: "" });

    const handleEditRow = (rowData) => {
        const val = { ...{ [`${rowData?.id}`]: true } };
        setEditingRows(val);
    };

    const handleSave = async (rowData, options, e) => {
        options?.rowEditor?.onSaveClick(e);
        const val = { ...{ [`${rowData?.id}`]: true } };
        setEditingRows(val);
    };

    const actions = (rowData, options) => {
        return (
            <>
                {options.rowEditor?.editing ? (
                    <>
                        <a
                            className="cursor-pointer"
                            onClick={(e) => handleSave(rowData, options, e)}
                        >
                            <img src={SaveIcon} />
                        </a>
                        <a
                            className="cursor-pointer"
                            onClick={(e) =>
                                options.rowEditor?.onCancelClick &&
                                options.rowEditor?.onCancelClick(e)
                            }
                        >
                            {" "}
                            <img src={CrossIcon} />
                        </a>
                    </>
                ) : (
                    <>
                        <CustomOverlay>
                            <ul className="no-style p-0">
                                <li
                                    className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                    onClick={() => handleEditRow(rowData)}
                                >
                                    <i className="pi pi-file-edit text-dark"></i>
                                    Edit
                                </li>
                                <li
                                    className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
                                    onClick={() => {
                                        setIdToDelete({
                                            id: rowData?.id,
                                            index: options?.rowIndex,
                                        });
                                        setDeleteModal(true);
                                    }}
                                >
                                    <i className="pi pi-trash  text-dark"></i> Delete
                                </li>
                            </ul>
                        </CustomOverlay>
                    </>
                )}
            </>
        );
    };

    const onRowEditChange = (e) => {
        setEditingRows(e.data);
    };

    const modalContent = () => {
        return (
            <span>
                Are you sure you want to delete the selected room from the list?
                This action cannot be undone.
            </span>
        );
    };

    const columns = useMemo(
        () => [
            {
                name: "No. of Tenants",
                accessor: "number_of_tenant",
                value: true,
                editor: (options) => DropdownEditor({ name: "number_of_tenant", options: options, list: TenantsOptions, allValues: allValues }),
                body: (options) => <CustomViewInput value={getTenantName(options.number_of_tenant)} spanIcon={SizeM2} />
            },
            {
                name: "Abtracted Allowed Size",
                accessor: "abstract_allowed_size",
                value: true,
                editor: (options) => NumberEditor({ name: "abstract_allowed_size", options: options, inputIcon: SizeM2, allValues: allValues }),
                body: (options) => <CustomNumberViewInput value={options.abstract_allowed_size} spanIcon={SizeM2} />
            },
            {
                name: "Net Rent by Sqm",
                accessor: "net_rent",
                value: true,
                editor: (options) => NumberEditor({ name: "net_rent", options: options, inputIcon: EuroIcon, allValues: allValues }),
                body: (options) => <CustomAmountViewInput value={options.net_rent} />
            },
            {
                name: "Gross Base Rent",
                accessor: "gross_base_rent",
                value: true,
                editor: (options) => NumberEditor({ name: "gross_base_rent", options: options, inputIcon: EuroIcon, allValues: allValues }),
                body: (options) => <CustomAmountViewInput value={options.gross_base_rent} />
            },
        ],
        [allValues]
    );

    const rowEditValidator = async (rowData, options) => {
        console.log("rowData", rowData)
        if (showFormErrors(rowData)) {
            dispatch(
                updateBaseRentsAction(rowData, dispatch, (res) => {
                    let values = [...allValues];
                    values[options.rowIndex] = rowData;
                    setAllValues(values);
                    setEditingRows({});
                    return true;
                })
            );
        } else {
            return false;
        }
    };

    const onDelete = () => {
        setLoading(true);
        dispatch(
            deleteBaseRentsAction(idToDelete?.id, setLoading, dispatch, (res) => {
                let values = [...allValues];
                let filtered = values.filter((item, itemIndex) => itemIndex !== idToDelete?.index)
                setAllValues(filtered)
                setIdToDelete({ id: "", index: "" });
                setDeleteModal(false);
            })
        );
    };

    return (
        <CustomForm title={title} header={header}>
            <CustomViewTable
                allValues={allValues}
                editingRows={editingRows}
                onRowEditChange={onRowEditChange}
                rowEditValidator={rowEditValidator}
                onRowEditSave={handleSave}
                columns={columns}
                actions={actions}
            />
            <CustomDeleteModal
                isOpen={deleteModal}
                setIsOpen={setDeleteModal}
                body={modalContent}
                onSubmit={onDelete}
                loading={loading}
                item={"base rent"}
            />
        </CustomForm>
    );
}
